import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/store'
import {Toast, Dialog, Notify, Button, Row, Col, Image} from 'vant';
import util from '@/libs/util'

import '@/assets/style/common.scss'
import '@/assets/font_icon/iconfont.css'

Vue.config.productionTip = false

Vue.use(Toast).use(Dialog).use(Notify).use(Button).use(Row).use(Col).use(Image)

Object.defineProperty(Vue.prototype, '$util', {value: util})


// eslint-disable-next-line
const _hmt = _hmt || [];
// eslint-disable-next-line
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
    const hm = document.createElement('script');
    hm.src = "https://hm.baidu.com/hm.js?9a607b20234d58fd71294a514bd6256a";
    const s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
}());

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
